const probBarDirective = function(): Record<string, any> {
	return {
		restrict: "E",
		scope: {
			leftProb: "="
		},
		link: function(scope, elem) {
			function drawBar() {
				const leftProb = scope.leftProb;
				const marker = (leftProb === 0 || leftProb === 1) ? "" : `<div class="prob-bar-marker" style="left: ${leftProb * 100}%"></div>`;
				elem.html(`<div class="prob-bar-body">
					${marker}
					<div class="prob-bar-inner" style="width: ${leftProb === 1 ? 110 : leftProb * 100}%"></div>
				</div>`);
			}
			
			drawBar();

			scope.$watch("leftProb", newVal => {
				if (typeof newVal !== "undefined" && newVal !== null) {
					drawBar();
				}
			});
		}
	};
};

export default probBarDirective;